export interface Country {
  code: string;
  name: string;
}

// Countries commonly used in international wire transfers
export const WIRE_COUNTRIES: Country[] = [
  { code: "US", name: "Estados Unidos" },
  { code: "CA", name: "Canadá" },
  { code: "GB", name: "Reino Unido" },
  { code: "AU", name: "Austrália" },
  { code: "JP", name: "Japão" },
  { code: "SG", name: "Singapura" },
  { code: "HK", name: "Hong Kong" },
  { code: "CH", name: "Suíça" },
  { code: "NZ", name: "Nova Zelândia" },
  { code: "BR", name: "Brasil" },
  { code: "IN", name: "Índia" },
  { code: "KR", name: "Coreia do Sul" },
  { code: "IL", name: "Israel" },
  { code: "AE", name: "Emirados Árabes" },
  { code: "ZA", name: "África do Sul" },
];

// SEPA countries (EU + EEA)
export const SEPA_COUNTRIES: Country[] = [
  { code: "DE", name: "Alemanha" },
  { code: "FR", name: "França" },
  { code: "IT", name: "Itália" },
  { code: "ES", name: "Espanha" },
  { code: "NL", name: "Países Baixos" },
  { code: "BE", name: "Bélgica" },
  { code: "AT", name: "Áustria" },
  { code: "PT", name: "Portugal" },
  { code: "IE", name: "Irlanda" },
  { code: "FI", name: "Finlândia" },
  { code: "GR", name: "Grécia" },
  { code: "LU", name: "Luxemburgo" },
  { code: "SK", name: "Eslováquia" },
  { code: "SI", name: "Eslovênia" },
  { code: "EE", name: "Estônia" },
  { code: "LV", name: "Letônia" },
  { code: "LT", name: "Lituânia" },
  { code: "CY", name: "Chipre" },
  { code: "MT", name: "Malta" },
  { code: "HR", name: "Croácia" },
  { code: "BG", name: "Bulgária" },
  { code: "RO", name: "Romênia" },
  { code: "CZ", name: "Tchéquia" },
  { code: "DK", name: "Dinamarca" },
  { code: "SE", name: "Suécia" },
  { code: "PL", name: "Polônia" },
  { code: "HU", name: "Hungria" },
  { code: "NO", name: "Noruega" },
  { code: "IS", name: "Islândia" },
  { code: "LI", name: "Liechtenstein" },
  { code: "CH", name: "Suíça" },
  { code: "MC", name: "Mônaco" },
  { code: "SM", name: "San Marino" },
  { code: "GB", name: "Reino Unido" },
];

// All countries combined (deduplicated by code)
export const ALL_COUNTRIES: Country[] = (() => {
  const map = new Map<string, Country>();
  [...WIRE_COUNTRIES, ...SEPA_COUNTRIES, { code: "MX", name: "México" }].forEach((c) => {
    if (!map.has(c.code)) map.set(c.code, c);
  });
  return Array.from(map.values()).sort((a, b) => a.name.localeCompare(b.name, "pt-BR"));
})();

// Get countries for a specific payment rail
export function getCountriesForRail(rail: string): Country[] {
  switch (rail) {
    case "wire":
      return WIRE_COUNTRIES;
    case "sepa":
      return SEPA_COUNTRIES;
    case "spei":
      return [{ code: "MX", name: "México" }];
    default:
      return ALL_COUNTRIES;
  }
}
